import { Skeleton } from '@/components/custom';

const DataTableMobileSkeleton = ({ count = 5 }: { count?: number }) => {
	const keys = Array.from({ length: count }, () => crypto.randomUUID());

	return (
		<div className="space-y-4">
			{keys.map(key => (
				<div key={key} className="p-4 border rounded-lg bg-card shadow-xs">
					<div className="flex items-start justify-between gap-3">
						<Skeleton className="h-14 w-14 rounded-md shrink-0" />
						<div className="flex-1 space-y-2">
							<div className="flex gap-1">
								<Skeleton className="h-5 w-14 rounded-full" />
								<Skeleton className="h-5 w-14 rounded-full" />
							</div>
							<Skeleton className="h-4 w-28" />
							<Skeleton className="h-4 w-36" />
						</div>
						<div className="flex items-center gap-1">
							<Skeleton className="h-8 w-8 rounded" />
							<Skeleton className="h-8 w-8 rounded" />
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default DataTableMobileSkeleton;
